// Últimas solicitudes externas al servidor OAuth/MCP (evidencia de lo que realmente pide ChatGPT).
import { useState } from 'react';
import api from '../../../lib/api';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { ListChecks, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { fmtFechaHora } from './oauthUtils';

const tone = (s) => (s < 300 ? 'bg-emerald-100 text-emerald-700' : s < 500 ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-700');

export function OAuthAccesos() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const cargar = async () => {
    setBusy(true);
    try { const r = await api.get('/oauth/admin/accesos', { params: { limit: 60 } }); setRows(r.data.accesos || []); } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo cargar'); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="oauth-accesos">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-semibold">Últimas solicitudes al servidor OAuth / MCP</p>
          <p className="text-xs text-muted-foreground">Qué pidió ChatGPT (u otro cliente), con código HTTP, método MCP y user-agent. Se conservan 7 días.</p>
        </div>
        <Button size="sm" variant="outline" onClick={cargar} disabled={busy} data-testid="oauth-btn-accesos">{busy ? <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> : <ListChecks className="mr-1 h-3.5 w-3.5" />} {rows ? 'Actualizar' : 'Ver solicitudes'}</Button>
      </div>
      {rows && (rows.length === 0 ? <p className="text-xs text-muted-foreground" data-testid="oauth-accesos-empty">Sin solicitudes registradas.</p> : (
        <div className="max-h-80 overflow-auto rounded-lg border">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-slate-50"><tr className="text-left text-muted-foreground"><th className="px-2 py-1.5">Hora</th><th className="px-2 py-1.5">Método</th><th className="px-2 py-1.5">Ruta</th><th className="px-2 py-1.5">Estado</th><th className="px-2 py-1.5">Auth</th><th className="px-2 py-1.5">Cliente (UA)</th></tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-t" data-testid="oauth-acceso-row">
                  <td className="whitespace-nowrap px-2 py-1 text-muted-foreground">{fmtFechaHora(r.ts)}</td>
                  <td className="px-2 py-1 font-mono">{r.method}{r.mcp_method ? <span className="text-muted-foreground"> · {r.mcp_method}</span> : ''}</td>
                  <td className="max-w-[320px] truncate px-2 py-1 font-mono" title={`${r.path} ${JSON.stringify(r.query || {})}\n${r.detalle || ''}`}>{r.path}</td>
                  <td className="px-2 py-1"><Badge className={`${tone(r.status)} hover:${tone(r.status)}`}>{r.status}</Badge></td>
                  <td className="px-2 py-1">{r.auth}</td>
                  <td className="max-w-[260px] truncate px-2 py-1 text-muted-foreground" title={`${r.ua}\nIP ${r.ip} · host ${r.host}`}>{r.ua}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
